<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="green"
    sbTooltip="{{ 'lang.admin.clientManagement.newClient' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'plus'"
    [sbRouterLink]="util.RoutingID.adminClientManagementCreate"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.admin.clientManagement' | translate}}"
  [itemsData]="clients"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'clients'">

  <!------------------------------

Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.email' | translate }}
      </th>
      <th>
        {{ 'lang.globals.identifier' | translate }}
      </th>
      <th>
        {{ 'lang.address.street' | translate }}
      </th>
      <th>
        {{ 'lang.address.street2' | translate }}
      </th>
      <th>
        {{ 'lang.address.zip' | translate }}
      </th>
      <th>
        {{ 'lang.address.city' | translate }}
      </th>
      <th>
        {{ 'lang.address.borough' | translate }}
      </th>
      <th>
        {{ 'lang.address.county' | translate }}
      </th>
      <th>
        {{ 'lang.address.state' | translate }}
      </th>
      <th>
        {{ 'lang.address.country' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

Table Body

------------------------------->
  <ng-template #tbody let-client>
    <tr>
      <td>
        {{ client?.id }}
      </td>
      <td>
        {{ client?.name }}
      </td>
      <td>
        {{ client?.primaryCompany?.email }}
      </td>
      <td>
        {{ client?.primaryCompany?.identifier }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.street }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.street2 }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.zip }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.city }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.borough }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.county }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.state }}
      </td>
      <td>
        {{ client?.primaryCompany?.address?.country }}
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="client.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(client, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
